import { Box, Button, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { APP_ROUTES } from 'shared/constants';

export default function JobActions({ jobId }: { jobId: string; }) {
    const { t } = useTranslation('myJobs');

    return (
        <Root>
            <Button component={ Link }
                to={ APP_ROUTES.jobDetails(jobId) }
                variant="contained"
                color="primary"
            >
                { t('actions.viewDetails') }
            </Button>
        </Root>
    );
}

const Root = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(4)
}));
